import { render, staticRenderFns } from "./SetPrinterFood.vue?vue&type=template&id=4cc3b30c&scoped=true&"
import script from "./SetPrinterFood.vue?vue&type=script&lang=js&"
export * from "./SetPrinterFood.vue?vue&type=script&lang=js&"
import style0 from "./SetPrinterFood.vue?vue&type=style&index=0&id=4cc3b30c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc3b30c",
  null
  
)

export default component.exports